export default "__VITE_ASSET__35039b4f__"